export default {
    name: "diagnostics",
    component: () => import(/* auth-router-module */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: "new",
            name: "diagnostics-new",
            meta: {
                breadcrumbs: [],
                title: "Nuevo Diagnóstico"
            },
            component: () => import('@/modules/diagnostics/views/New.vue')
        },
        {
            path: "",
            name: "diagnostics-index",
            meta: {
                breadcrumbs: [],
                title: "Diagnósticos"
            },
            component: () => import('@/modules/diagnostics/views/Index.vue')
        },
        {
            path: "edit/:id",
            name: "diagnostics-edit",
            meta: {
                breadcrumbs: [],
                title: "Editar Diagnóstico"
            },
            component: () => import('@/modules/diagnostics/views/Edit.vue')
        }
    ]
}